import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { getDurationString } from 'src/app/utils/duration-formatter.utils';

@Component({
    selector: 'app-my-qualification-status-widget-demo',
    templateUrl: './my-qualification-status-widget-demo.component.html',
    styleUrl: './my-qualification-status-widget-demo.component.scss',
    standalone: false
})
export class MyQualificationStatusWidgetDemoComponent {
  private testData = {
    tenantIddTimeMinutesTarget: 300,
    sumIddTimeMinutesReached: 180,
  };

  employeeChartData = [
    {
      label: this.translateService.instant('DASHBOARD.HOURS-MISSING'),
      value: 0,
      originalValue: 0,
    },
    {
      label: this.translateService.instant('DASHBOARD.HOURS-SPENT'),
      value: 0,
      originalValue: 0,
    },
  ];

  employeeQualification = {
    current: '00:00h',
    target: '00:00h',
    missing: '00:00h',
  };

  constructor(
    private translateService: TranslateService,
  ) {
    this.customizeEmployeeChartText = this.customizeEmployeeChartText.bind(this);
    this.customizeEmployeeChartPoint = this.customizeEmployeeChartPoint.bind(this);
  }

  ngOnInit() {
    const data = this.testData;

    const missingTime = Math.max(0, data.tenantIddTimeMinutesTarget - data.sumIddTimeMinutesReached);

    this.employeeQualification.current = getDurationString(data.sumIddTimeMinutesReached);
    this.employeeQualification.target = getDurationString(data.tenantIddTimeMinutesTarget);
    this.employeeQualification.missing = getDurationString(missingTime);

    const currentPercentage = Math.round((100 * data.sumIddTimeMinutesReached) / data.tenantIddTimeMinutesTarget) || 0;

    this.employeeChartData[0].value = currentPercentage <= 100 ? 100 - currentPercentage : 0;
    this.employeeChartData[1].value = currentPercentage;

    this.employeeChartData[0].originalValue = data.tenantIddTimeMinutesTarget;
    this.employeeChartData[1].originalValue = data.sumIddTimeMinutesReached;

    this.employeeChartData = [...this.employeeChartData];
  }

  customizeEmployeeChartPoint(pointInfo: any) {
    return pointInfo.argument === this.translateService.instant('DASHBOARD.HOURS-MISSING')
      ? { color: '#f53d3dcc' }
      : { color: '#66cc66cc' };
  }

  customizeEmployeeChartText(arg: any) {
    const currentPercentage = Math.round((100 * this.employeeChartData[1].originalValue) / this.employeeChartData[0].originalValue) || 0;

    if (arg.pointName === this.translateService.instant('DASHBOARD.HOURS-MISSING')) {
      return `${arg.pointName}: ${this.employeeQualification.missing} (${currentPercentage < 100 ? 100 - currentPercentage : 0}%)`;
    } else {
      return `${arg.pointName}: ${this.employeeQualification.current} (${currentPercentage > 100 ? 100 : currentPercentage}%)`;
    }
  }
}
